module.exports = __webpack_public_path__ + "images/emoji/back.66463348c947e6101523.png";